import { node } from "~/util/dom";
import Report from "./index";
import { IRouteState } from "./interfaces";
import { getReportDefectOptions } from "./options";
import { reportWaitForLogin, reportAnalytics } from "./util";
import { _ } from "~/i18n";
import { ROUTE_CONST } from "~/route/const";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";

export function createRouteReport(routeState: IRouteState) {
	const desc = node("p", { className: "route-report" });
	const isPubt = routeState.route.params.criterion === ROUTE_CONST.types.pubt.criterion[0];
	const isTrip = routeState.route.items.length === 1;
	const isBoat = routeState.route.params.type === ROUTE_CONST.TYPE_BOAT;
	const waypoint = routeState.route.errorObject?.waypoint_index || -1;

	//reportLine2RouteWater
	const secondLineMsg = isTrip
		? "report.reportLine2Trip"
		: isBoat
			? "report.reportLine2RouteBoat"
			: "report.reportLine2Route";
	const secondLine = node("span", {
		className: "route-report-line second",
		innerHTML: ` ${_(secondLineMsg, {
			linkStart: `<a href="#">`,
			linkEnd: `</a>`,
		})}`,
	});
	const link = secondLine.querySelector("a");
	const routeMsg = _(isTrip ? "report.tripMsg" : "report.routeMsg", {
		routeFrom: routeState.route.items[0].title,
		...isTrip
			? {}
			: {
				routeTo: routeState.route.items[routeState.route.items.length - 1].title,
				routeItems: routeState.route.items.map(item => `* ${item.title}`).join("\n"),
			},
	});

	if (link) {
		link.setAttribute("data-log-ignore", "true");
		link.addEventListener("click", async () => {
			Notifications.destroy();
			reportAnalytics({
				text: "nahlaste problém",
				origin: "routing",
				type: "broken",
			});

			await reportWaitForLogin();

			const report = new Report(getReportDefectOptions(routeMsg, "routing"));

			report.open();
		});
	}

	if (isBoat) {
		desc.append(
			node("span", { className: "route-report-line", textContent: _("report.reportLineRouteType") }),
		);
	} else {
		desc.append(
			node("span", { className: "route-report-line", textContent: _(isTrip ? "report.reportLine1Trip" : waypoint > -1 ? "report.reportLine1RouteWaypoint" : "report.reportLine1Route", { waypoint: waypoint + 1 }) }),
		);

		if (!isPubt) {
			desc.append(secondLine);
		}
	}

	Notifications.notify({
		content: desc,
		type: NOTIFICATIONS_TYPE.ERROR,
	});
}
